module.exports = "https://cdn.thelire.com/ins/resource/lite_hybird_ios_face.12fb2c73eeba6210ba971ce5bb5e8db6.jpg";